export const SEMANTIC_COLORS = Object.freeze([
  'primary',
  'success',
  'info',
  'warning',
  'upgrade',
  'secondary',
  'muted',
]);

export const TYPE_COLORS = Object.freeze([
  'dark',
  'light',
  'darkMuted',
  'lightMuted',
  'link',
]);

export const SIZES = Object.freeze(['lg', 'md', 'sm']);
